<template>
  <div class="wrapper-box">
    <web-header></web-header>
    <web-slide :data="data"></web-slide>
    <section class="section wow fadeIn">
      <div class="container">
        <div class="columns">
          <div class="column is-2">

          </div>
          <div class="column is-9 has-text-centered">
            <p>
              <img src="~@/assets/images/misics/piramide_pasturas.jpg" alt="piramide_pasturas">
            </p>

          </div>

          <div class="column is-2">

          </div>
        </div>

      </div>
    </section>
    <web-products :products="products"></web-products>
    <web-parallax></web-parallax>
    <web-footer></web-footer>
    <web-arrow-up></web-arrow-up>
  </div>
</template>
<script>
import header from "@/components/header";
import slide from "@/components/slide";
import content from "@/components/content";
import parallax from "@/components/parallax";
import footer from "@/components/footer";
import products from "@/components/categories/products";
import arrowUp from "@/components/arrowUp.vue";
import bg from "../../assets/images/categories/banners/titulo_naturalhay.jpg";
import bgMob from "../../assets/images/categories/banners/titulo_naturalhay_mobile.jpg";

import img1 from "../../assets/images/products/pasturas_henoenrama.jpg";
import img2 from "../../assets/images/products/pasturas_alfalfaenrama.jpg";
import img3 from "../../assets/images/products/pasturas_alfalfaencubos.jpg";
import img4 from "../../assets/images/products/pasturas_alfalfaenpellet.jpg";

export default {
  name: "naturalHayPasturas",
  data() {
    return {
      data: [
        {
          html:
            " <h1>NATURAL HAY - PASTURAS</h1><p>Base nutricional de los roedores.<br>Favorece el buen desgaste de dientes y una optima digestión.</p>",
          style:
            "background:url(" +
            this.getBg() +
            ") no-repeat; background-size:cover;    background-position: center; height:300px; "
        }
      ],
      products: [
        {
          image: img1,
          title: "HENO EN RAMA",
          description: `
            Nutritivas pasturas curadas al sol. <br>
            El Heno “Nelsoni Ranch” constituye la base nutricional de conejos, cobayos, chinchillas, hamsters y otros pequeños roedores. Es una delicia natural que proporciona fibra con bajo contenido de calcio, disminuyendo la probabilidad de enfermedades en el tracto urinario. <br>
            El Heno “Nelsoni Ranch” es esencial para la salud general de sus pequeñas mascotas, ya que ayuda en su proceso digestivo natural. También puede ser utilizado como cama.<br>
            No Contiene ningún tipo de agregado ni conservantes.<br>
            Se recomienda dar Heno “Nelsoni Ranch” a su mascota junto con una comida nutritiva y balanceada como la línea de Alimentos Balanceados “Nelsoni Ranch”
            Darle Heno “Nelsoni Ranch” a su pequeña mascota cuida la salud del cuerpo y los dientes dándole bienestar general
            (Los conejos, cobayos, chinchillas, hamsters y otros pequeños animales tienen una necesidad innata de masticar con el fin de desgastar sus dientes incisivos que no paran de crecer )
            Ingredientes: variedades de pasturas tales como Lotus, trébol y cebadilla deshidratada al sol.
            `,
          extraData: "Presentación 500 gr."
        },
        {
          image: img2,
          title: "ALFALFA EN RAMA",
          description: `Nutritiva pastura de alfalfa curada al sol<br>
            La Alfalfa en Rama “Nelsoni Ranch” es un complemento natural ideal para conejos, cobayos, chinchillas, hamsters y otros pequeños roedores. <br>
            Es una delicia que proporciona fibra. También puede ser utilizado como cama para su pequeña mascota.<br>
            Ingredientes: alfalfa deshidratada al sol.
            `,
          extraData: "Presentación 500 gr."
        },
        {
          image: img3,
          title: "ALFALFA EN CUBOS",
          description: `Nutritivos bloques naturales de pastura de alfalfa curada al sol<br>
          Los Cubos de Alfalfa “Nelsoni Ranch” son un complemento natural ideal para conejos, cobayos, chinchillas, hamsters y otros pequeños roedores.Los Cubos de Alfalfa “Nelsoni Ranch” son esenciales para la salud general de los conejos, chinchillas, hamsters, cobayos y otros roedores, ya que ayuda en su proceso digestivo natural. <br>
          No Contiene ningún tipo de agregado ni conservantes.<br>
          Se recomienda dar Cubos de Alfalfa “Nelsoni Ranch” a su mascota junto con una comida nutritiva y balanceada como la línea de Alimentos Balanceados  “Nelsoni Ranch”<br>
          Darle Cubos de Alfalfa “Nelsoni Ranch” a su pequeña mascota cuida la salud del cuerpo y los dientes dándole bienestar general<br>
          Beneficios: 
          <br>
          -	100% aprovechamiento<br>
          -	65% de ahorro en el transporte y el almacenamiento<br>
          -	Alta digestibilidad <br>
          -	100% Natural<br>
          -	Calidad Constante <br>
          -	Excelente Palatabilidad <br>
          -	Fácil dosificación<br>
          -	Libre de moho y polvo<br>
          Información nutricional: Proteína entre 23% y 27%<br>
          Ingredientes: Alfalfa deshidratada al sol. <br>
          `,
          extraData: "Presentación: 500 gr."
        },
        {
          image: img4,
          title: "ALFALFA PELLET",
          description: `Los pellets de alfalfa de Nelsoni Ranch compuesto por las mejores alfalfas, manteniendo a su mascota vital y feliz. <br>
Complemento esencial en la dieta de animales como conejos, cobayos, chinchillas, gerbos entre otros.<br>
Ingredientes: alfalfa.
`,
          extraData: "Presentación: 500 gr."
        }
      ]
    };
  },
  components: {
    webHeader: header,
    webSlide: slide,
    webContent: content,
    webParallax: parallax,
    webFooter: footer,
    webProducts: products,
    webArrowUp: arrowUp
  },
  methods: {
    detectmob() {
      if (window.screen.availWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    getBg() {
      if (this.detectmob()) {
        return bgMob;
      }
      return bg;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/categories/naturalHayPasturas.vue